import { MantineSpacing, Radio, Group, Stack } from '@mantine/core';
import { ReactElement } from 'react';

interface Props {
  data: { label: ReactElement | string; value: string }[];
  value: string;
  onChange: (value: string) => void;
  label?: string;
  vertical?: boolean;
  spacing?: MantineSpacing;
}

export const RadioGroup = ({ data, value, onChange, label, vertical = false, spacing = 'sm' }: Props) => {
  if (!vertical) {
    return (
      <Group>
        {data.map((radio, index) => (
          <Radio key={index} value={radio.value} label={radio.label} />
        ))}
      </Group>
    );
  }
  return (
    <Radio.Group value={value} onChange={onChange} label={label}>
      <Stack mt={spacing}>
        {data.map((radio, index) => (
          <Radio key={index} value={radio.value} label={radio.label} />
        ))}
      </Stack>
    </Radio.Group>
  );
};
